/**
 * @flow
 * @relayHash 00fe056ea7605ca7c2d11af899b466a6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FollowOnQuestionsInput = {|
  responses?: ?$ReadOnlyArray<?follow_on_response>,
  clientMutationId?: ?string,
|};
export type follow_on_response = {|
  questionName: string,
  answerText?: ?$ReadOnlyArray<?string>,
|};
export type FollowOnQuestionsMutationVariables = {|
  input: FollowOnQuestionsInput
|};
export type FollowOnQuestionsMutationResponse = {|
  +relayFollowOnQuestions: ?{|
    +successMessage: ?boolean
  |}
|};
export type FollowOnQuestionsMutation = {|
  variables: FollowOnQuestionsMutationVariables,
  response: FollowOnQuestionsMutationResponse,
|};
*/


/*
mutation FollowOnQuestionsMutation(
  $input: FollowOnQuestionsInput!
) {
  relayFollowOnQuestions(input: $input) {
    successMessage
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FollowOnQuestionsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "relayFollowOnQuestions",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FollowOnQuestionsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "successMessage",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FollowOnQuestionsMutation",
    "type": "RelayMutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "FollowOnQuestionsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "FollowOnQuestionsMutation",
    "id": null,
    "text": "mutation FollowOnQuestionsMutation(\n  $input: FollowOnQuestionsInput!\n) {\n  relayFollowOnQuestions(input: $input) {\n    successMessage\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b20b1745870ab985ee6c30c5b034500e';
module.exports = node;
